import {atom, useAtomValue, useSetAtom} from 'jotai';
import {useCallback} from 'react';

const internalAtom = atom(false);

export const useGoPremiumModalState = () => useAtomValue(internalAtom);

export const useGoPremiumModalToggle = () => {
    const setAtom = useSetAtom(internalAtom);
    return useCallback(() => setAtom((prev) => !prev), [setAtom]);
};

export const useGoPremiumModalClose = () => {
    const setAtom = useSetAtom(internalAtom);
    return useCallback(() => setAtom(false), [setAtom]);
};
